import { orderBy } from 'lodash';

export function orderElements<E extends { order: number }>(elements: E[]): E[] {
  return orderBy(elements, ['order'], ['asc']);
}
